import { ONBOARDING_STATUSES } from "../../types/onboarding";
import LeadsView from "./LeadsView";

export default function OnboardingCustomers() {
  return (
    <LeadsView
      endpoint="/api/admin/operations/onboarding"
      title="Onboarding customers"
      subtitle="Pólizas en proceso de alta — click en una fila para ver todos los datos."
      availableStatuses={ONBOARDING_STATUSES}
      defaultStatuses={ONBOARDING_STATUSES}
    />
  );
}
